import { useEffect, useRef, useState } from "react";
import { imagePages } from "./Picture";

import GalleryContent from "./GalleryContent";
import GalleryPagination from "./GalleryPagination";
import IntroSection from "./IntroSection";
import FooterUI from "./FooterUI";
import './styles/gallery.layout.css';

function Gallery() {
  const [page, setPage] = useState(0);
  const [visible, setVisible] = useState(false);
  const sectionRef = useRef(null);

  /* 갤러리 스크롤 등장 */
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.3 }
    );

    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section
      ref={sectionRef}
      className={`gallery-section ${visible ? "show" : ""}`}
    >
      <GalleryContent page={page} imagePages={imagePages} />

      <GalleryPagination
        page={page}
        setPage={setPage}
        total={imagePages.length}
      />

      <IntroSection />

      <FooterUI />
    </section>
  );
}

export default Gallery;